/**
 * The two material families of API 579-1 Fig 4.5 (piping Type-A criteria).
 *
 * Pulled out of `ffsComponentClassification.ts` into its own tiny module so
 * that both `ffsComponentClassification.ts` (the classifier) and
 * `pipingMaterialFamily.ts` (the material-string → group mapper) can import
 * it without creating a circular dependency between those two files.
 * `ffsComponentClassification.ts` re-exports both names for backward
 * compatibility with existing imports.
 */
export const PIPING_MATERIAL_GROUPS = [
  'carbon-low-alloy',
  'high-alloy-nonferrous',
] as const
export type PipingMaterialGroup = (typeof PIPING_MATERIAL_GROUPS)[number]
